module.exports = __webpack_public_path__ + "img/logo_vslbooster.f77c9eb5.png";